import l from "./index.es192.js";
import m from "./index.es193.js";
import a from "./index.es194.js";
import t from "./index.es195.js";
import r from "./index.es196.js";
import n from "./index.es197.js";
import o from "./index.es198.js";
import f from "./index.es199.js";
import i from "./index.es200.js";
import c from "./index.es201.js";
import u from "./index.es202.js";
import s from "./index.es203.js";
import p from "./index.es204.js";
import g from "./index.es205.js";
import v from "./index.es206.js";
import E from "./index.es207.js";
import O from "./index.es208.js";
import S from "./index.es209.js";
import d from "./index.es210.js";
import h from "./index.es211.js";
import C from "./index.es212.js";
import F from "./index.es213.js";
import M from "./index.es214.js";
import b from "./index.es215.js";
import _ from "./index.es216.js";
import x from "./index.es217.js";
import I from "./index.es218.js";
import R from "./index.es219.js";
import T from "./index.es220.js";
import j from "./index.es221.js";
import e from "react";
const k = [
  null,
  /* @__PURE__ */ e.createElement(u, { id: "number-in-ten-male-1" }),
  /* @__PURE__ */ e.createElement(s, null),
  /* @__PURE__ */ e.createElement(p, null),
  /* @__PURE__ */ e.createElement(g, null),
  /* @__PURE__ */ e.createElement(v, null),
  /* @__PURE__ */ e.createElement(E, null),
  /* @__PURE__ */ e.createElement(O, null),
  /* @__PURE__ */ e.createElement(S, null),
  /* @__PURE__ */ e.createElement(d, null),
  /* @__PURE__ */ e.createElement(h, null)
], q = [
  null,
  /* @__PURE__ */ e.createElement(l, null),
  /* @__PURE__ */ e.createElement(m, null),
  /* @__PURE__ */ e.createElement(a, null),
  /* @__PURE__ */ e.createElement(t, null),
  /* @__PURE__ */ e.createElement(r, null),
  /* @__PURE__ */ e.createElement(n, null),
  /* @__PURE__ */ e.createElement(o, null),
  /* @__PURE__ */ e.createElement(f, null),
  /* @__PURE__ */ e.createElement(i, null),
  /* @__PURE__ */ e.createElement(c, null)
], w = [
  null,
  /* @__PURE__ */ e.createElement(C, null),
  /* @__PURE__ */ e.createElement(F, null),
  /* @__PURE__ */ e.createElement(M, null),
  /* @__PURE__ */ e.createElement(b, null),
  /* @__PURE__ */ e.createElement(_, { id: "number-in-10-female-5" }),
  /* @__PURE__ */ e.createElement(x, null),
  /* @__PURE__ */ e.createElement(I, null),
  /* @__PURE__ */ e.createElement(R, null),
  /* @__PURE__ */ e.createElement(T, null),
  /* @__PURE__ */ e.createElement(j, null)
], ue = { male: k, female: w, child: q };
export {
  l as Child1,
  c as Child10,
  m as Child2,
  a as Child3,
  t as Child4,
  r as Child5,
  n as Child6,
  o as Child7,
  f as Child8,
  i as Child9,
  C as Female1,
  j as Female10,
  F as Female2,
  M as Female3,
  b as Female4,
  _ as Female5,
  x as Female6,
  I as Female7,
  R as Female8,
  T as Female9,
  u as Male1,
  h as Male10,
  s as Male2,
  p as Male3,
  g as Male4,
  v as Male5,
  E as Male6,
  O as Male7,
  S as Male8,
  d as Male9,
  q as child,
  ue as default,
  w as female,
  k as male
};
//# sourceMappingURL=index.es100.js.map
